const byteConversion = (byte, unit) => {
  if (typeof byte === 'number' && typeof unit === 'string') {
    switch (unit) {
      case 'TB': {
        return byte / 2 ** 40;
      }
      case 'GB': {
        return byte / 2 ** 30;
      }
      case 'MB': {
        return byte / 2 ** 20;
      }
      case 'KB': {
        return byte / 2 ** 10;
      }
      default: {
        return byte;
      }
    }
  }

  return NaN;
};

export default byteConversion;
